import { ApiIndividualResponse } from '@/types/api'
import { IUser, UserInclude } from '@/types/user'
import { ApiService, RequestOptions } from './api'

export type IUserPutPayload = Omit<
  IUser,
  | '_id'
  | 'isActive'
  | 'roles'
  | 'email'
  | 'password'
  | 'permissions'
  | 'createdAt'
  | 'updatedAt'
>

export type IUserPatchPayload = {
  firstName?: string
  lastName?: string
  jobRole?: string | null
  linkedIn?: string | null
}

type GetMeArgs = {
  include?: UserInclude[]
  options?: RequestOptions
}

export class UserService {
  static readonly path = '/users'
  static readonly mePath = '/users/me'
  static readonly userPath = '/users/:id'
  static readonly httpClient = new ApiService()

  static async getMe({ include = [], options }: GetMeArgs = {}): Promise<
    ApiIndividualResponse<IUser>
  > {
    const queryParams = new URLSearchParams()

    if (include.length > 0) {
      for (const item of include) {
        queryParams.append('include', item)
      }
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `${UserService.mePath}?${queryString}`
      : UserService.mePath

    return await UserService.httpClient.get(url, options)
  }

  static async getUserById(
    userId: string,
    { include = [], options }: GetMeArgs = {}
  ): Promise<ApiIndividualResponse<IUser>> {
    const queryParams = new URLSearchParams()

    if (include.length > 0) {
      for (const item of include) {
        queryParams.append('include', item)
      }
    }

    const queryString = queryParams.toString()
    const url = queryString
      ? `${UserService.path}/${userId}?${queryString}`
      : `${UserService.path}/${userId}`

    return await UserService.httpClient.get(url, options)
  }

  /**
   * @deprecated Use patchUser instead for partial updates
   */
  static async putUser(userId: string, userData: IUserPutPayload) {
    if (!userId) {
      throw new Error('userId is required')
    }

    return await UserService.httpClient.put(
      UserService.userPath.replace(':id', userId),
      userData
    )
  }

  static async patchUser(
    userId: string,
    userData: IUserPatchPayload,
    options?: RequestOptions
  ) {
    if (!userId) {
      throw new Error('userId is required')
    }

    return await UserService.httpClient.patch(
      UserService.userPath.replace(':id', userId),
      userData,
      options
    )
  }
}
